<template>
  <div class="d-flex align-center" data-testid="tasklist__toolbar-actions-group">
    <!-- <v-tooltip bottom content-class="tooltip-bottom">
                                        <template  v-slot:activator="{ on, attrs }" >
                                            <v-btn icon v-bind="attrs" v-on="on"  @click="saveFilter(tableFilterHeader)">
                                                <v-icon>mdi-image-auto-adjust</v-icon>
                                            </v-btn>
                                        </template>
                                      <span>Save filter</span>
                                    </v-tooltip>

                                    <v-tooltip bottom content-class="tooltip-bottom">
                                        <template  v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on"  @click="clearFilter()">
                                                <v-icon>mdi-file-restore-outline</v-icon>
                                            </v-btn>
                                        </template>
                                      <span>Reset all filter</span>
                                    </v-tooltip> -->

    <!-- <v-btn text class=" mb-2 " color="red" dark>
                            Save filter 
                            <v-icon
                            dark
                            right
                            >
                            mdi-filter-remove
                            </v-icon></v-btn>   -->
    <!-- /* TODO: Temporarily set to display: none; for current requirements. Will be updated in future versions. */ -->
    <div class="d-none">
      <v-slide-x-reverse-transition>
        <lb-string
          v-if="showSearch"
          v-model="searchQuery"
          placeholder="Search.."
          hidedetails
          label=""
          :isClearable="false"
        />
      </v-slide-x-reverse-transition>
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="toggleSearch">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </template>
        <span>Search</span>
      </v-tooltip>
    </div>
    <!-- Clear Filter Button -->
    <v-btn
      v-if="hasActiveTableFilter"
      outlined
      small
      class="mr-2"
      color="primary"
      @click="$emit('clear-filter')"
      data-testid="tasklist__toolbar-clear-filter-btn"
    >
      <v-icon left data-testid="tasklist__toolbar-clear-filter-icon">mdi-filter-remove</v-icon>
      <span>Clear Filter</span>
    </v-btn>

    <v-tooltip bottom content-class="tooltip-bottom" v-if="chatbotEnabled">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off"
          @click="$emit('redirect-chatbot')"
        >
          <img
            data-testid="chatbot-icon"
            src="/img/icons/fbc-icons/ArkNoa.svg"
            :alt="$constants.ASK_NOA_LABEL"
            class="chat-agent-img"
          />
        </v-btn>
      </template>
      <span>{{ $constants.ASK_NOA_LABEL }}</span>
    </v-tooltip>
    <!-- Save Layout Button -->
    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          :color="columnOrderChanged ? 'white' : ''"
          :disabled="!columnOrderChanged || loading"
          :class="['', { 'primary': columnOrderChanged }]"
          @click="$emit('save-column-order')"
          data-testid="tasklist__save-column-order-btn"
        >
          <v-icon>mdi-content-save-outline</v-icon>
        </v-btn>
      </template>
      <span>Save Layout</span>
    </v-tooltip>

    <v-tooltip bottom content-class="tooltip-bottom" v-if="overDueDate">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="error"
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off"
          @click="$emit('overdue-filter')"
          data-testid="tasklist__toolbar-overdue-btn"
          >
          <img src="/img/icons/fbc-icons/FilterOverDue.svg" data-testid="tasklist__toolbar-overdue-icon"/>
        </v-btn>
      </template>
      <span>Filter Overdue</span>
    </v-tooltip>

    <v-tooltip bottom content-class="tooltip-bottom" v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off"
          @click="$emit('overdue-filter')"
          data-testid="tasklist__toolbar-overdue-btn"
          ><img src="/img/icons/fbc-icons/FilterOverDue.svg" data-testid="tasklist__toolbar-overdue-icon"/></v-btn
        >
      </template>
      <span>Filter Overdue</span>
    </v-tooltip>
    <!-- Show bulk upload icon only for Preparer role -->
    <v-tooltip bottom content-class="tooltip-bottom" v-if="userType === $constants.TASK_LIST_CONSTANTS.ROLES.PREPARER">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          :disabled="selectItem.length === 0"
          class="shadow-off pa-1"
          @click="selectItem.length > 0 && $emit('bulk-workpaper-upload')"
          data-testid="tasklist__toolbar-bulk-upload-btn"
        >
          <v-icon data-testid="tasklist__toolbar-bulk-upload-icon">mdi-upload</v-icon>
        </v-btn>
      </template>
      <span v-if="selectItem.length === 0">Select a task to upload</span>
      <span v-else><span>Bulk upload</span></span>
    </v-tooltip>
    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off"
          @click="$emit('get-task-details')"
          data-testid="tasklist__toolbar-status-btn"
          ><img src="/img/icons/fbc-icons/AllTaskStatusReport.svg" data-testid="tasklist__toolbar-status-icon"/></v-btn
        >
      </template>
      <span>All Tasks Status Report</span>
    </v-tooltip>

    <v-menu offset-y transition="slide-y-transition" data-testid="tasklist__toolbar-export-menu">
      <template v-slot:activator="{ on, attrs }">
        <v-tooltip bottom content-class="tooltip-bottom">
          <template
            v-slot:activator="{
              on: tooltipOn,
              attrs: tooltipAttrs,
            }"
          >
            <v-btn
              icon
              v-bind="{ ...attrs, ...tooltipAttrs }"
              v-on="{ ...on, ...tooltipOn }"
              data-testid="tasklist__toolbar-export-btn"
            >
              <img src="/img/icons/fbc-icons/ExportIcon.svg" data-testid="tasklist__toolbar-export-icon"/>
            </v-btn>
          </template>
          <span>Export</span>
        </v-tooltip>
      </template>

      <v-list
        style="
          max-height: 50vh;
          overflow: hidden;
          z-index: 13 !important;
          width: 20vh;
        "
        class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
        data-testid="tasklist__toolbar-export-list"
      >
        <v-list-title class="ma-0 all-width" data-testid="tasklist__toolbar-export-list-title">
          <div class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1 justify-space-between">
            <p class="ma-0 font-weight-bold" data-testid="tasklist__toolbar-export-list-title-label">Export</p>
            <v-icon color="primary" data-testid="tasklist__toolbar-export-list-title-icon">mdi-information-outline</v-icon>
          </div>
        </v-list-title>
        <v-divider></v-divider>
        <v-list-item
          style="max-height: 25vh; overflow: scroll"
          class="d-flex all-width align-start pa-0 ma-0 flex-column"
          data-testid="tasklist__toolbar-export-list-items"
        >
          <v-list-item
            class="d-flex pa-0 px-2 ma-0 all-width"
            @click="$emit('download-excel')"
            data-testid="tasklist__toolbar-export-list-item-excel"
          >
            <v-icon class="pr-2" data-testid="tasklist__toolbar-export-list-item-excel-icon">mdi-download</v-icon>
            <span data-testid="tasklist__toolbar-export-list-item-excel-label">Download Excel</span>
          </v-list-item>
        </v-list-item>
      </v-list>
    </v-menu>

    <lb-comment
      heading="Conversation"
      v-if="showConversation"
      width="600"
      :recurring="false"
      :recurringText="''"
      :closed="metadata.stage !== 0"
      @markread="$emit('mark-conversation-read')"
      :notify="!metadata.conversation_read"
      :getapi="'/v2/financialclose/project/getconversation/' + metadata._id"
      :sendapi="'/v2/financialclose/project/addconversation/' + metadata._id"
      :readapi="'/v2/financialclose/project/markreadconversation/' + metadata._id"
      data-testid="tasklist__conversation-component"
    />

    <v-menu
      ref="bulkmenu"
      :close-on-content-click="false"
      offset-y
      transition="slide-y-transition"
      v-if="selectItem.length > 0"
      data-testid="tasklist__bulk-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-tooltip bottom content-class="tooltip-bottom">
          <template
            v-slot:activator="{
              on: tooltipOn,
              attrs: tooltipAttrs,
            }"
          >
            <v-btn
              icon
              v-bind="{ ...attrs, ...tooltipAttrs }"
              v-on="{ ...on, ...tooltipOn }"
              data-testid="tasklist__bulk-btn"
            >
              <v-icon data-testid="tasklist__bulk-icon">mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <span>Bulk Actions</span>
        </v-tooltip>
      </template>

      <v-list
        style="
          max-height: 50vh;
          overflow: visible;
          z-index: 13 !important;
          width: 30vh;
        "
        class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width bulk-actions-menu"
        data-testid="tasklist__bulk-list"
      >
        <div
          class="ma-0 d-flex font-weight-bold pa-2 primary font-weight-bold text-font-size-md all-width"
          data-testid="tasklist__bulk-list-title"
        >
          Bulk Actions
          <v-spacer></v-spacer>
        </div>
        <!-- Manager Menu -->
        <v-list-item
          class="d-flex flex-column all-width align-start pa-2 ma-0 bulkactionscroll"
          v-if="userType === 'manager'"
          data-testid="tasklist__bulk-list-items-manager"
        >
          <v-list-item
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="$emit('bulk-action', 'preparer')"
            data-testid="tasklist__bulk-edit-preparer-btn"
          >
            <v-icon class="pr-2" data-testid="tasklist__bulk-edit-preparer-icon">mdi-pencil-outline</v-icon>
            <span data-testid="tasklist__bulk-edit-preparer-label">Edit Preparer</span>
          </v-list-item>

          <v-list-item
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="$emit('bulk-action', 'approver')"
            data-testid="tasklist__bulk-edit-approver-btn"
          >
            <v-icon class="pr-2" data-testid="tasklist__bulk-edit-approver-icon">mdi-pencil-outline</v-icon>
            <span data-testid="tasklist__bulk-edit-approver-label">Edit Approver</span>
          </v-list-item>

          <v-list-item
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="$emit('bulk-update-duedate')"
            data-testid="tasklist__bulk-edit-duedate-btn"
          >
            <v-icon class="pr-2" data-testid="tasklist__bulk-edit-duedate-icon">mdi-pencil-outline</v-icon>
            <span data-testid="tasklist__bulk-edit-duedate-label">Edit Due Date</span>
          </v-list-item>

          <v-list-item
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="$emit('bulk-edit-threshold')"
            data-testid="tasklist__bulk-edit-threshold-enforcement-btn"
          >
            <v-icon class="pr-2" data-testid="tasklist__bulk-edit-threshold-enforcement-icon">mdi-pencil-outline</v-icon>
            <span data-testid="tasklist__bulk-edit-threshold-enforcement-label">Edit Threshold Enforcement</span>
          </v-list-item>

          <v-divider data-testid="tasklist__bulk-divider"></v-divider>

          <v-list-item
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="$emit('bulk-edit-tasks')"
            v-if="isManager"
            data-testid="tasklist__bulk-edit-tasks-btn"
          >
            <v-icon class="pr-2" data-testid="tasklist__bulk-edit-tasks-icon">mdi-text-box-edit</v-icon>
            <span data-testid="tasklist__bulk-edit-tasks-label">Bulk Edit Tasks</span>
          </v-list-item>
        </v-list-item>

        <!-- Preparer Menu -->
        <v-list-item
          class="d-flex flex-column all-width align-start pa-2 ma-0 bulkactionscroll"
          v-else-if="userType === 'preparer'"
          data-testid="tasklist__bulk-list-items-preparer"
        >
          <v-list-item class="cursor-pointer hoverable-caccounting all-width radius-small" data-testid="tasklist__bulk-preparer-comment-item">
            <lb-comment
              :showname="true"
              heading="Conversation"
              v-if="showConversation"
              width="600"
              :recurring="false"
              :recurringText="''"
              :closed="metadata.stage !== 0"
              @markread="$emit('mark-conversation-read')"
              :notify="!metadata.conversation_read"
              :getapi="'/v2/financialclose/project/getconversation/' + metadata._id"
              :sendapi="'/v2/financialclose/project/addconversation/' + metadata._id"
              :readapi="'/v2/financialclose/project/markreadconversation/' + metadata._id"
              data-testid="tasklist__bulk-preparer-comment"
            />
          </v-list-item>
          <v-divider data-testid="tasklist__bulk-divider"></v-divider>
          <v-list-item
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="$emit('bulk-unlink-bot')"
            v-if="isManager"
            data-testid="tasklist__bulk-unlink-bot-btn"
          >
            <v-icon class="pr-2" data-testid="tasklist__bulk-unlink-bot-icon">mdi-link-off</v-icon>
            <span data-testid="tasklist__bulk-unlink-bot-label">Unlink {{$constants.BOT_NAME}}</span>
          </v-list-item>
        </v-list-item>

        <!-- Approver Menu -->
        <v-list-item
          class="d-flex flex-column all-width align-start pa-2 ma-0 bulkactionscroll"
          v-else-if="userType === 'approver'"
          data-testid="tasklist__bulk-list-items-approver"
        >
          <v-list-item
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="$emit('bulk-download')"
            data-testid="tasklist__bulk-download-btn"
          >
            <v-icon class="pr-2" data-testid="tasklist__bulk-download-icon">mdi-download</v-icon>
            <span data-testid="tasklist__bulk-download-label">Download</span>
          </v-list-item>

          <v-list-item class="cursor-pointer hoverable-caccounting all-width radius-small" data-testid="tasklist__bulk-approver-comment-item">
            <lb-comment
              :showname="true"
              heading="Conversation"
              v-if="showConversation"
              width="600"
              :recurring="false"
              :recurringText="''"
              :closed="metadata.stage !== 0"
              @markread="$emit('mark-conversation-read')"
              :notify="!metadata.conversation_read"
              :getapi="'/v2/financialclose/project/getconversation/' + metadata._id"
              :sendapi="'/v2/financialclose/project/addconversation/' + metadata._id"
              :readapi="'/v2/financialclose/project/markreadconversation/' + metadata._id"
              data-testid="tasklist__bulk-approver-comment"
            />
          </v-list-item>
          <v-divider data-testid="tasklist__bulk-divider"></v-divider>
          <v-list-item
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="$emit('bulk-change-status', 'approve')"
            data-testid="tasklist__bulk-approve-btn"
          >
            <v-icon class="pr-2" data-testid="tasklist__bulk-approve-icon">mdi-check-circle</v-icon>
            <span data-testid="tasklist__bulk-approve-label">Approve</span>
          </v-list-item>
          <v-list-item
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="$emit('bulk-change-status', 'reject')"
            data-testid="tasklist__bulk-reject-btn"
          >
            <v-icon class="pr-2" data-testid="tasklist__bulk-reject-icon">mdi-close-circle</v-icon>
            <span data-testid="tasklist__bulk-reject-label">Reject</span>
          </v-list-item>

          <v-divider data-testid="tasklist__bulk-divider"></v-divider>
          <v-list-item
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="$emit('bulk-unlink-bot')"
            v-if="isManager"
            data-testid="tasklist__bulk-unlink-bot-btn"
          >
            <v-icon class="pr-2" data-testid="tasklist__bulk-unlink-bot-icon">mdi-link-off</v-icon>
            <span data-testid="tasklist__bulk-unlink-bot-label">Unlink {{$constants.BOT_NAME}}</span>
          </v-list-item>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Customize Column Menu Component -->
    <CustomizeColumnMenu
      v-model="menuOpen"
      :headers="tableHeadersFilter"
      :page-name="page_name"
      :loading="loading"
      :show-header-info-icon="true"
      color="primary"
      data-testid-prefix="tasklist"
      @apply="$emit('apply-columns', $event)"
      @save="$emit('save-columns', $event)"
    />
  </div>
</template>

<script>
import CustomizeColumnMenu from '../../components/CustomizeColumnMenu/CustomizeColumnMenu.vue';

export default {
  name: 'TaskbarToolbar',
  components: {
    CustomizeColumnMenu
  },
  props: {
    hasActiveTableFilter: {
      type: Boolean,
      default: false
    },
    chatbotEnabled: {
      type: Boolean,
      default: false
    },
    columnOrderChanged: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    metadata: {
      type: Object,
      default: () => ({})
    },
    selectItem: {
      type: Array,
      default: () => []
    },
    userType: {
      type: String,
      default: 'preparer'
    },
    overDueDate: {
      type: Boolean,
      default: false
    },
    tableHeadersFilter: {
      type: Array,
      default: () => []
    },
    page_name: {
      type: String,
      default: 'tasklist'
    },
    showConversation: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showSearch: false,
      searchQuery: '',
      menuOpen: false
    };
  },
  computed: {
    isManager() {
      const userId = this.$store.state.user?.id;
      const managerList = this.metadata?.managerlist;
      if (!Array.isArray(managerList) || !userId) return false;
      return managerList.some((id) => String(id) === String(userId));
    }
  },
  methods: {
    toggleSearch() {
      this.showSearch = !this.showSearch;
    }
  }
};
</script>

<style scoped lang="scss">
// Component-specific styles here
</style>
